export default [
  {
    path: "/forgot-password",
    name: "forgotPassword",
    component: () => import("../../../views/pages/auth/forgetpassword.vue"),
  },
];
